import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";

const ROADMAP = [
  { label: "BUSINESS IDEA", tag: null },
  { label: "BUSINESS STRUCTURE", tag: null },
  { label: "PAN / TAX", tag: null },
  { label: "GST", tag: "IF APPLICABLE" },
  { label: "MSME / UDYAM", tag: "IF ELIGIBLE" },
  { label: "LOCAL REGISTRATIONS", tag: null },
  { label: "INDUSTRY LICENSES", tag: "IF APPLICABLE" },
  { label: "IP PROTECTION", tag: null },
  { label: "FOOD / PRODUCT CERTIFICATIONS", tag: "IF APPLICABLE" },
  { label: "QUALITY CERTIFICATIONS", tag: null },
  { label: "BUSINESS READY TO OPERATE & GROW", tag: "READY", final: true },
];

const ACCENTS = ["#FF8800", "#00B0FF", "#00E676"];

export function Roadmap() {
  return (
    <section data-testid="roadmap-section" className="relative py-20 sm:py-28 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(255,136,0,0.05),transparent_55%)] pointer-events-none" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="text-center max-w-3xl mx-auto mb-14"
        >
          <p className="font-mono-tech text-xs tracking-[0.35em] text-[#00B0FF] uppercase mb-4">The Journey</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white" data-testid="roadmap-headline">
            BUSINESS COMPLIANCE <span className="text-gradient-saffron">ROADMAP</span>
          </h2>
          <p className="mt-5 text-base text-slate-400 leading-relaxed">
            A typical path from idea to fully operating business. Not every business requires
            every item — LaunchLab helps identify what applies to yours.
          </p>
        </motion.div>

        <div className="relative max-w-2xl mx-auto" data-testid="roadmap-flow">
          <div className="absolute left-1/2 top-3 bottom-3 w-px bg-gradient-to-b from-[#FF8800] via-[#00B0FF] to-[#00E676] opacity-40 -translate-x-1/2" />
          <div className="space-y-4">
            {ROADMAP.map((step, i) => (
              <motion.div
                key={step.label}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-30px" }}
                transition={{ duration: 0.45, delay: 0.02 * i }}
                className="relative flex flex-col items-center"
                data-testid={`roadmap-step-${i}`}
              >
                <div
                  className={`glass rounded-xl px-6 py-4 flex items-center gap-3 z-10 transition-colors duration-300 hover:border-white/25 ${
                    step.final ? "border-[#00E676]/40 shadow-[0_0_35px_rgba(0,230,118,0.12)]" : ""
                  }`}
                >
                  <span
                    className="font-mono-tech text-[10px] font-semibold"
                    style={{ color: step.final ? "#00E676" : ACCENTS[i % 3] }}
                  >
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span
                    className={`font-display font-semibold tracking-[0.08em] text-sm sm:text-base text-center ${
                      step.final ? "text-gradient-india font-extrabold" : "text-white"
                    }`}
                  >
                    {step.label}
                  </span>
                  {step.tag && step.tag !== "READY" && (
                    <span className="font-mono-tech text-[8px] tracking-[0.2em] px-2 py-0.5 rounded-full border border-[#00B0FF]/40 text-[#00B0FF]">
                      {step.tag}
                    </span>
                  )}
                </div>
                {i < ROADMAP.length - 1 && <ArrowDown className="w-4 h-4 text-slate-600 mt-2" />}
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
